import _objectWithoutProperties from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["placement", "arrowProps", "show", "popper"];
import React, { useState, useEffect, useRef } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Overlay from 'react-bootstrap/Overlay';
import SVGLocked from "../assets/svglocked.js";
import SVGUnlocked from "../assets/svgunlocked.js";
import SVGBuilding from "../assets/svgbuilding.js";
import SVGCopy from "../assets/svgcopy.js";
import { editorCheckLabel } from "./editorCheckLabel.js";
import { withResponseErrorHandling } from './withResponseErrorHandling.js';
import { convertActionToCasper, convertActionToDisplay } from './helper.js';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SmallIcon(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/_jsx("span", {
    style: {
      'display': 'inline-block'
    },
    children: /*#__PURE__*/_jsx("span", {
      className: "header-image header-mode dropdown-image",
      children: icon
    })
  });
}
function SmallUnlockedIcon() {
  return /*#__PURE__*/_jsx(SmallIcon, {
    icon: /*#__PURE__*/_jsx(SVGUnlocked, {})
  });
}
function SmallLockedIcon() {
  return /*#__PURE__*/_jsx(SmallIcon, {
    icon: /*#__PURE__*/_jsx(SVGLocked, {})
  });
}
function SmallBuildingIcon() {
  return /*#__PURE__*/_jsx(SmallIcon, {
    icon: /*#__PURE__*/_jsx(SVGBuilding, {})
  });
}
function modeToTitle(objMode, objOrganizationName) {
  return objMode === 'public' ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmallUnlockedIcon, {}), "Public"]
  }) : objMode === 'private' ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmallLockedIcon, {}), "Private"]
  }) : objMode === 'organization' ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmallBuildingIcon, {}), objOrganizationName]
  }) : objMode ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SmallLockedIcon, {}), "".concat(objMode[0].toUpperCase()).concat(objMode.slice(1))]
  }) : /*#__PURE__*/_jsx("i", {
    children: "Fetching..."
  });
}
function getTitle(orgAction) {
  var convertedAction = convertActionToDisplay(orgAction);
  return convertedAction;
}

// Get Link Component
var GetLink = function GetLink(_ref2) {
  var objMode = _ref2.objMode,
    setObjMode = _ref2.setObjMode,
    objPK = _ref2.objPK,
    objType = _ref2.objType,
    selfCanWrite = _ref2.selfCanWrite,
    csrftoken = _ref2.csrftoken,
    isAuthenticated = _ref2.isAuthenticated,
    selfIsAdmin = _ref2.selfIsAdmin,
    setError = _ref2.setError,
    setNumLoading = _ref2.setNumLoading,
    isSharingEnabled = _ref2.isSharingEnabled,
    refreshData = _ref2.refreshData,
    orgAction = _ref2.orgAction,
    objOrganization = _ref2.objOrganization,
    target_url = _ref2.target_url,
    changeGroup = _ref2.changeGroup,
    linkUUID = _ref2.linkUUID;
  var copy_success_target = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show_copy_success = _useState2[0],
    setShowCopySuccess = _useState2[1];
  var _useState3 = useState("Viewer"),
    _useState4 = _slicedToArray(_useState3, 2),
    role = _useState4[0],
    setRole = _useState4[1]; // for organization slu
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    disableOrg = _useState6[0],
    setDisabledOrg = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    planExist = _useState8[0],
    setPlanExist = _useState8[1];

  //Strip to avoid loading flicker
  var cleanPK = objType === 'dataset' || objType === 'namedendpoint' ? (objPK || '').replace(/-/g, '') : objPK;
  var CopyUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(target_url).concat(cleanPK);
  var copyURL = function copyURL() {
    navigator.clipboard.writeText(CopyUrl);
    setShowCopySuccess(true);
  };
  var handleChange = function handleChange(role) {
    var convertedOrgAction = convertActionToCasper(role);
    setRole(role);
    withResponseErrorHandling(fetch("/api/v2/update/share/link/", {
      method: "PUT",
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        pk: linkUUID,
        obj_type: objType,
        mode: objMode,
        org_action: convertedOrgAction
      })
    }).then(function (res) {
      return res.json();
    }), 'inviting users', setNumLoading, setError).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      }
    }).catch(function (e) {});
  };
  useEffect(function () {
    if (objOrganization) {
      if (objOrganization['is_personal']) {
        setDisabledOrg(true);
      } else {
        setDisabledOrg(false);
      }
      if (objOrganization['plan_name'] || selfIsAdmin || objOrganization['has_plan_or_not_cloud']) {
        setPlanExist(true);
      } else {
        setPlanExist(false);
      }
    }
  }, [objOrganization, selfIsAdmin]);
  if (objOrganization) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Form, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Group, {
              children: /*#__PURE__*/_jsxs(Row, {
                className: "share-copy-row",
                children: [/*#__PURE__*/_jsxs(Col, {
                  xs: 11,
                  sm: 11,
                  md: 11,
                  lg: 11,
                  xl: 11,
                  children: [/*#__PURE__*/_jsx(Form.Control, {
                    type: "text",
                    value: CopyUrl,
                    disabled: true
                  }), objType === 'namedendpoint' ? /*#__PURE__*/_jsx("p", {
                    children: /*#__PURE__*/_jsx("a", {
                      target: "_blank",
                      href: "".concat(window.location.protocol, "//").concat(window.location.host, "/docs/UDF/gfql-udf-api/"),
                      children: "Docs"
                    })
                  }) : null]
                }), /*#__PURE__*/_jsxs(Col, {
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: 1,
                  xl: 1,
                  children: [/*#__PURE__*/_jsx("div", {
                    id: "btn-copy",
                    title: "Copy URL",
                    className: "header-image header-mode float-right c-pointer",
                    children: /*#__PURE__*/_jsx("span", {
                      ref: copy_success_target,
                      onClick: copyURL,
                      onMouseLeave: function onMouseLeave() {
                        return setShowCopySuccess(false);
                      },
                      style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                      },
                      children: /*#__PURE__*/_jsx(SVGCopy, {
                        classname: "header-svg"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Overlay, {
                    target: copy_success_target.current,
                    show: show_copy_success,
                    placement: "bottom",
                    children: function children(_ref3) {
                      var placement = _ref3.placement,
                        arrowProps = _ref3.arrowProps,
                        _show = _ref3.show,
                        popper = _ref3.popper,
                        props = _objectWithoutProperties(_ref3, _excluded);
                      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
                        style: _objectSpread({
                          zIndex: 10000,
                          position: 'absolute',
                          backgroundColor: '#198754',
                          padding: '2px 10px',
                          color: 'white',
                          borderRadius: 3
                        }, props.style),
                        children: "Copy successful"
                      }));
                    }
                  })]
                })]
              })
            })
          })
        })
      }), objType === 'namedendpoint' ? null : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Form, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              children: [selfCanWrite === false ? /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx("i", {
                  children: "Ask owner for Editor access for futher control"
                })
              }) : null, "Choose whether anyone with the link can view, or only invited individuals"]
            })
          })
        }), /*#__PURE__*/_jsx(Form, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(Form.Group, {
                children: /*#__PURE__*/_jsxs(DropdownButton, {
                  id: "dropdown-basic-button",
                  title: modeToTitle(objMode, objOrganization['name']),
                  variant: "light",
                  onSelect: changeGroup,
                  disabled: !isSharingEnabled,
                  children: [/*#__PURE__*/_jsxs(Dropdown.Item, {
                    eventKey: "public",
                    disabled: selfCanWrite === false,
                    children: [/*#__PURE__*/_jsx(SmallUnlockedIcon, {}), "Public ", editorCheckLabel(selfCanWrite === false)]
                  }), planExist ? /*#__PURE__*/_jsxs(Dropdown.Item, {
                    eventKey: "private",
                    disabled: selfCanWrite === false
                    // disabled={disabled}
                    ,

                    children: [/*#__PURE__*/_jsx(SmallLockedIcon, {}), "Private ", editorCheckLabel(selfCanWrite === false)]
                  }) : /*#__PURE__*/_jsxs(Dropdown.Item, {
                    eventKey: "private",
                    disabled: true,
                    style: {
                      backgroundColor: "#e9ecef"
                    }
                    // disabled={disabled}
                    ,

                    children: [/*#__PURE__*/_jsx(SmallLockedIcon, {}), "Private ", editorCheckLabel(selfCanWrite === false), " (add plan to set as Private)"]
                  }), disableOrg === true ? /*#__PURE__*/_jsxs(Dropdown.Item, {
                    eventKey: "organization"
                    // disabled={selfCanWrite === false}
                    ,

                    disabled: disableOrg,
                    style: {
                      backgroundColor: "#e9ecef"
                    },
                    children: [/*#__PURE__*/_jsx(SmallBuildingIcon, {}), "Organization - unavailable; this item is in owner personal account", editorCheckLabel(selfCanWrite === false)]
                  }) : /*#__PURE__*/_jsx(_Fragment, {
                    children: planExist ? /*#__PURE__*/_jsxs(Dropdown.Item, {
                      eventKey: "organization",
                      disabled: selfCanWrite === false,
                      children: [/*#__PURE__*/_jsx(SmallBuildingIcon, {}), "Organization - ", objOrganization['name'], " ", editorCheckLabel(selfCanWrite === false)]
                    }) : /*#__PURE__*/_jsxs(Dropdown.Item, {
                      eventKey: "organization",
                      disabled: true,
                      style: {
                        backgroundColor: "#e9ecef"
                      },
                      children: [/*#__PURE__*/_jsx(SmallBuildingIcon, {}), "Organization - ", objOrganization['name'], " ", editorCheckLabel(selfCanWrite === false), " (add plan to set as Organization)"]
                    })
                  })]
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(Form, {
          children: /*#__PURE__*/_jsx(Row, {
            children: objMode === 'organization' ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Col, {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
                children: /*#__PURE__*/_jsx(Form.Group, {
                  children: orgAction ? /*#__PURE__*/_jsxs(DropdownButton, {
                    id: "dropdown-basic-button",
                    title: getTitle(orgAction),
                    variant: "primary btn-block",
                    "aria-expanded": "true",
                    disabled: !isSharingEnabled,
                    children: [/*#__PURE__*/_jsxs(Dropdown.Item, {
                      onClick: function onClick() {
                        return handleChange("Viewer");
                      },
                      disabled: !selfCanWrite,
                      children: ["Viewer ", editorCheckLabel(selfCanWrite === false)]
                    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
                      onClick: function onClick() {
                        return handleChange("Editor");
                      },
                      disabled: !selfCanWrite,
                      children: ["Editor ", editorCheckLabel(selfCanWrite === false)]
                    })]
                  }) : /*#__PURE__*/_jsxs(DropdownButton, {
                    id: "dropdown-basic-button",
                    title: role.charAt(0).toUpperCase() + role.substring(1),
                    variant: "primary btn-block",
                    "aria-expanded": "true",
                    disabled: !isSharingEnabled,
                    children: [/*#__PURE__*/_jsxs(Dropdown.Item, {
                      onClick: function onClick() {
                        return handleChange("Viewer");
                      },
                      disabled: !selfCanWrite,
                      children: ["Viewer ", editorCheckLabel(selfCanWrite === false)]
                    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
                      onClick: function onClick() {
                        return handleChange("Editor");
                      },
                      disabled: !selfCanWrite,
                      children: ["Editor ", editorCheckLabel(selfCanWrite === false)]
                    })]
                  })
                })
              })
            }) : null
          })
        })]
      })]
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
};
export default GetLink;